<div class="catalog-toolbar">
  <div id="selectSportButtonContainer">
    <app-sport-selector
      [sports]="sports$ | async"
      [selectedSport]="selectedSport$ | async"
      [dropDownPlacement]="isFixed ? 'bottom' : 'center'"
      (changeSport)="onChangeSport($event)"></app-sport-selector>
  </div>
  <div id="modes">
    <app-horizontal-scroller [isBackgroundLight]="true" [isSmall]="true">
      <div class="scroll-wrapper">
        <div id="modeButtons">
          @for (mode of modes$ | async; track $index) {
            <a
              [routerLink]="['/browse']"
              [fragment]="mode.name"
              class="mode-button-container"
              [ngClass]="{
                selected: (selectedMode$ | async).name === mode.name,
              }"
              [title]="'browse.toolbar.' + mode.name | translate"
              (click)="onChangeMode(mode)">
              <button [title]="'browse.toolbar.' + mode.name | translate">
                <span [class]="'icon icon-' + mode.icon"></span>
                <span class="mode-btn-label">{{
                  'browse.toolbar.' + mode.name | translate
                }}</span>
              </button>
            </a>
          }
        </div>
      </div>
    </app-horizontal-scroller>
  </div>
</div>
